import { csvEscape } from '@xver/utils/csv';
import { activityActor } from '@xver/utils/projects';

import { InstanceActivityItemModel } from '../../../../../apis/v1/instances/model';

export function activityRowsToCsv(
    items: InstanceActivityItemModel[],
    header: string[],
    systemActorLabel: string,
    someoneActorLabel: string
): string {
    const lines = [header.map(csvEscape).join(',')];
    for (const it of items) {
        lines.push(
            [
                it.created_at,
                it.type,
                it.description,
                activityActor(it, systemActorLabel, someoneActorLabel),
                it.ip_address,
            ]
                .map((v) => csvEscape(String(v ?? '')))
                .join(',')
        );
    }
    return lines.join('\r\n');
}
